<script setup lang="ts">
import { twMerge } from 'tailwind-merge'
import { cva } from 'class-variance-authority'
import type { VariantProps } from 'class-variance-authority'

const spanClasses = cva(
  'inline-block rounded bg-opacity-20 font-bold leading-4',
  {
    variants: {
      color: {
        blue: 'bg-blue-200 text-blue-200',
        purple: 'bg-purple-400 text-purple-400',
        gray: 'bg-uiGray-600 text-uiPrimary-100',
        green: 'bg-green-300 bg-opacity-10 text-green-300',
        yellow: 'bg-yellow-100 bg-opacity-10 text-yellow-100'
      },
      size: {
        lg: 'p-2',
        md: 'p-1 text-sm',
        sm: 'p-1 text-xs'
      }
    },
    defaultVariants: {
      color: 'green',
      size: 'sm'
    }
  }
)

type SpanProps = VariantProps<typeof spanClasses>

const props = withDefaults(
  defineProps<{
    class?: string | string[] | Record<string, boolean>
    color?: SpanProps['color']
    size?: SpanProps['size']
  }>(),
  {
    color: 'green',
    size: 'sm',
    class: ''
  }
)
</script>

<template>
  <span
    :class="
      twMerge(
        spanClasses({
          color: props.color,
          size: props.size,
          class: props.class
        })
      )
    "
  >
    <slot />
  </span>
</template>
